var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grey lighten-5 fill-height"},[_c('SignIn'),_vm._v(" "),_c('toaster')],1)}
var staticRenderFns = []

export { render, staticRenderFns }